import React from "react";

import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

const GrievancePolicy = () => {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="bg-half-170 bg-light d-table w-100">
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="pages-heading">
                <h1 className="title mb-3" style={{ fontSize: "2.5rem" }}>
                  Grievance Redressal Policy
                </h1>
                <p className="text-muted para-desc mx-auto mb-0">
                  In accordance with the Information Technology Act, 2000
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape Divider */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg viewBox="0 0 2880 48" fill="none">
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* Content Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="card shadow rounded border-0">
                <div className="card-body">
                  <div className="knowledge__content">
                    <h3 className="mb-4">
                      Grievance Redressal Mechanism – Formax Pay
                    </h3>

                    <p className="text-muted">
                      This Grievance Redressal Policy is framed in compliance
                      with the provisions of the{" "}
                      <strong>Information Technology Act, 2000</strong> and
                      applicable rules thereunder. Formax Pay is committed to
                      resolving customer grievances in a transparent, efficient,
                      and time-bound manner.
                    </p>

                    <h5 className="mt-4">1. Objective</h5>
                    <ul className="text-muted">
                      <li>
                        To provide a fair and structured grievance resolution
                        system
                      </li>
                      <li>
                        To comply with statutory and regulatory requirements
                      </li>
                      <li>To enhance customer trust and service quality</li>
                    </ul>

                    <h5 className="mt-4">2. Scope</h5>
                    <p className="text-muted">
                      This policy covers grievances related to:
                    </p>
                    <ul className="text-muted">
                      <li>Recharge and bill payment failures</li>
                      <li>Incorrect debit or duplicate transactions</li>
                      <li>Refunds and reversals</li>
                      <li>Wallet balance mismatch</li>
                      <li>Commission, settlement, or payout disputes</li>
                      <li>API transaction and technical issues</li>
                      <li>Service or platform-related complaints</li>
                    </ul>

                    <h5 className="mt-4">3. How to Raise a Grievance</h5>
                    <p className="text-muted">
                      Customers may raise a grievance through any of the
                      following channels:
                    </p>
                    <ul className="text-muted">
                      <li>
                        Email: <strong>helpdesk@formaxpay.com</strong>
                      </li>
                      <li>
                        WhatsApp / Phone Call: <strong>7890090500</strong>
                      </li>
                      <li>
                        Support section available on the Formax Pay dashboard
                      </li>
                    </ul>

                    <p className="text-muted">
                      Please provide your registered mobile number/User ID,
                      transaction reference ID, date of transaction, and issue
                      details for faster resolution.
                    </p>

                    <h5 className="mt-4">
                      4. Acknowledgement & Resolution Timeline
                    </h5>
                    <ul className="text-muted">
                      <li>
                        Grievances are acknowledged within{" "}
                        <strong>24 working hours</strong>
                      </li>
                      <li>
                        Recharge / payment issues:{" "}
                        <strong>3–5 working days</strong>
                      </li>
                      <li>
                        Refund-related issues: <strong>5–7 working days</strong>
                      </li>
                      <li>
                        API & technical issues:{" "}
                        <strong>2–4 working days</strong>
                      </li>
                      <li>
                        Settlement or commission disputes:{" "}
                        <strong>up to 5 working days</strong>
                      </li>
                    </ul>

                    <h5 className="mt-4">5. Escalation Matrix</h5>

                    <ul className="text-muted">
                      <li>
                        <strong>Level 1 – Helpdesk Support:</strong>
                        <br />
                        Email: helpdesk@formaxpay.com
                        <br />
                        WhatsApp / Phone: 7890090500
                      </li>
                      <li className="mt-2">
                        <strong>Level 2 – Senior Management:</strong>
                        <br />
                        Email: mijanur.haque@formaxit.com
                      </li>
                      <li className="mt-2">
                        <strong>Level 3 – Nodal Officer:</strong>
                        <br />
                        Email: nodal@formaxpay.com
                      </li>
                    </ul>

                    <h5 className="mt-4">
                      6. Nodal Officer Details (As per IT Act, 2000)
                    </h5>
                    <p className="text-muted mb-1">
                      <strong>Name:</strong> Mr. Ezazul Haque
                    </p>
                    <p className="text-muted mb-1">
                      <strong>Email:</strong> nodal@formaxpay.com
                    </p>
                    <p className="text-muted">
                      <strong>Address:</strong>
                      <br />
                      Formax IT Solutions Pvt Ltd,
                      <br />
                      Ground Floor, 16, Mochpole,
                      <br />
                      Near Junior School, Nabapally,
                      <br />
                      Barasat, Kolkata – 700126
                    </p>

                    <h5 className="mt-4">7. Customer Responsibilities</h5>
                    <ul className="text-muted">
                      <li>Provide correct and complete information</li>
                      <li>Avoid duplicate complaints for the same issue</li>
                      <li>Cooperate during investigation or verification</li>
                    </ul>

                    <h5 className="mt-4">8. Policy Review</h5>
                    <p className="text-muted">
                      Formax Pay reserves the right to modify this policy at any
                      time to comply with legal, regulatory, or operational
                      requirements. Updated versions will be published on this
                      page.
                    </p>

                    <h5 className="mt-4">9. Contact Information</h5>
                    <p className="text-muted mb-0">
                      <strong>
                        Formax Pay – A Division of Formax IT Solutions Pvt Ltd
                      </strong>
                      <br />
                      Email: helpdesk@formaxpay.com
                      <br />
                      Phone / WhatsApp: 7890090500
                      <br />
                      Website: https://www.formaxpay.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default GrievancePolicy;
